<template>
    <div>
        <button type="button" class="filter-tag uk-button uk-button-indigo-outline uk-flex uk-flex-middle" @click.stop="removeTag">
            <span>{{ filterTagText }}</span>
            <span class="uk-icon" uk-icon="close"></span>
        </button>
    </div>
</template>

<script>
    export default {
        name: "dr-filter-tag",
        props: ['filterTag', 'filterTagText', 'index', 'type'],
        methods: {
            removeTag() {
                if (this.type === 'checkbox') {
                    // Find the filter category and index
                    const filterCategory = this.filterTag.category;
                    
                    // Find the filter index by iterating through the filters array
                    const filterItems = this.$store.getters.filters[filterCategory].items;
                    const filterIndex = filterItems.findIndex(item => item.label === this.filterTag.label);
                    
                    if (filterIndex !== -1) {
                        // Remove the active filter
                        this.$store.dispatch('removeActiveFilter', {
                            filterCategory,
                            filterIndex
                        });
                    } else {
                        console.error(`Could not find filter with label "${this.filterTag.label}" in category "${filterCategory}"`);
                    }
                } else {
                    // Remove date filter
                    this.$store.dispatch('removeDateFilters');
                }
            }
        }
    }
</script>

<style lang="scss">
/* Стили уже определены в UIkit */
</style>
